<template>
    <div class="search-bar__vue">
        <form class="search-bar__product-form">
            <label>
                <span class="screen-reader-text" v-html="translations.search"></span>
                <input type="search" class="search-field" v-model="searchInput" name="s"
                       :placeholder="translations.search">
            </label>
            <input type="submit" class="search-submit search-bar__vue-submit" @click="preventSubmission"
                   :value="translations.search">
        </form>
        <div class="search-bar__results"
             :class="{ 'search-bar__results--loading' : loading, 'search-bar__results--has-results' : has_results }">
            <div class="search-bar__scroll-container">
                <div v-if="loading" class="vue__loader search-bar__results-loader"></div>
                <div class="container">
                    <div class="row">
                        <div class="col-6 search-bar__results-col">
                            <div v-if="loading === false && has_results === true" class="search-bar__results-title"
                                 v-html="translations.products"></div>
                            <ul v-if="results_catalog.post_results" class="search-bar__results-list">
                                <li v-for="post in results_catalog.post_results" class="search-bar__result">
                                    <a :href="post.link" class="search-bar__result-link">
                                        <figure class="search-bar__result-figure" v-if="post.meta.image">
                                            <img class="search-bar__result-image" :src="post.meta.image"
                                                 :alt="post.title.rendered"/>
                                        </figure>
                                        <div class="search-bar__result-content">
                                            <div v-if="post.title" class="search-bar__post-title"
                                                 v-html="post.title.rendered"></div>
                                            <div v-if="post.default_code_stimmt" class="search-bar__post-code">
                                                {{ post.default_code_stimmt }}
                                            </div>
                                        </div>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div class="col-6 search-bar__results-col">
                            <div v-if="loading === false && has_results === true" class="search-bar__results-title"
                                 v-html="translations.content"></div>
                            <ul v-if="results_content" class="search-bar__results-list">
                                <li v-for="post in results_content.slice(0,15)" class="search-bar__result">
                                    <a v-if="post.type !== 'catalogus'" :href="post.link"
                                       class="search-bar__result-content-link">
                                        <span v-html="post.title.rendered"></span>
                                        <span class="search-bar__result-type" v-if="post.type"
                                              v-html="postType(post.type)"></span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div v-if="loading === false && has_results === true" class="row search-bar__buttons">
                        <div class="col-6">
                            <a v-if="search_catalog_url" :href="search_catalog_url" class="button button--ghost"
                               v-html="translations.all_search_results"></a>
                        </div>
                        <div class="col-6">
                            <a v-if="search_content_url" :href="search_content_url" class="button button--ghost"
                               v-html="translations.all_search_results"></a>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>

import axios from 'axios'

export default {
    data() {
        return {
            searchInput: '',
            baseUrl: '',
            results_catalog: [],
            results_content: [],
            loading: false,
            has_results: false,
            search_catalog_url: '',
            search_content_url: '',
            language: 'nl',
            translations: {
                search: "Zoeken",
                products: "Producten",
                content: "Content",
                all_search_results: "Alle zoekresultaten",
                page: "pagina",
                knowledge: "blog",
                oplossing: "oplossing",
                ervaring: "ervaring",
                product: "product",
            }
        }
    },
    mounted: function () {
        let searchBar = document.querySelector("#search-bar");
        this.language = searchBar.dataset.language;

        if (searchBar.dataset.translations) {
            let translations = JSON.parse(searchBar.dataset.translations);

            if (typeof translations == "object") {
                this.translations = JSON.parse(searchBar.dataset.translations);
            }
        }
    },
    watch: {
        searchInput: function (value) {
            let _this = this;
            this.results = [];

            if (value.length > 2) {
                _this.searchTimeOut(value);
            }
        }
    },
    methods: {
        postType(value) {
            if (this.translations[value]) {
                return this.translations[value];
            }

            return value;
        },
        preventSubmission(e) {
            e.preventDefault();
            let searchUrl = `${window.location.origin}/catalogus/#!/custom_search=${this.searchInput}&falling_height=0,3000&list_price=0,300000&orderby=list_price&order=asc&on_website_lappset=1&lang=${this.language}&per_page=30&page=1`;
            window.location.href = searchUrl;
        },
        searchTimeOut(value) {
            let language = this.language;
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            this.timer = setTimeout(() => {
                this.loading = true;
                this.allSearchCalls(value);

                // Set search urls
                this.search_catalog_url = window.location.origin + `/catalogus/#!/custom_search=${value}&falling_height=0,3000&list_price=0,300000&orderby=list_price&order=asc&on_website_lappset=1&lang=${language}&per_page=30&page=1`;
                this.search_content_url = window.location.origin + `/?s=${value}`;
            }, 800);
        },
        allSearchCalls(searchInputValue) {
            let _this = this;
            console.log('Called');
            _this.results_catalog = [];
            _this.results_content = [];

            let getProducts = function getProducts() {
                let fetchUrl = `${window.location.origin}/wp-json/wp/v2/catalogus?falling_height=0,3000&list_price=0,300000&orderby=list_price&order=asc&on_website_lappset=1&lang=${_this.language}&per_page=10&page=1&custom_search=${searchInputValue}`;
                return _this.axiosSearch(fetchUrl, 'Catalogus');
            }

            let getContent = function getContent() {
                let fetchUrl = `${window.location.origin}/wp-json/relevanssi/v1/search?per_page=10&page=1&keyword=${searchInputValue}`;
                return _this.axiosSearch(fetchUrl, 'Pages');
            }
            // let getKnowledge = function getKnowledge() {
            //
            //     let fetchUrl = window.location.origin;
            //     fetchUrl += '/wp-json/wp/v2/knowledge?per_page=10&page=1&search='
            //     fetchUrl += searchInputValue;
            //
            //     return _this.axiosSearch(fetchUrl, 'Knowledge');
            // }
            // let getExperience = function getExperience() {
            //
            //     let fetchUrl = window.location.origin;
            //     fetchUrl += '/wp-json/wp/v2/ervaring?per_page=10&page=1&search='
            //     fetchUrl += searchInputValue;
            //
            //     return _this.axiosSearch(fetchUrl, 'Experiences');
            // }
            // let getProduct = function getProduct() {
            //
            //     let fetchUrl = window.location.origin;
            //     fetchUrl += '/wp-json/wp/v2/product?per_page=10&page=1&search='
            //     fetchUrl += searchInputValue;
            //
            //     return _this.axiosSearch(fetchUrl, 'Products');
            // }
            // let getFaq = function getFaq() {
            //
            //     let fetchUrl = window.location.origin;
            //     fetchUrl += '/wp-json/wp/v2/faq?per_page=10&page=1&search='
            //     fetchUrl += searchInputValue;
            //
            //     return _this.axiosSearch(fetchUrl, 'FAQs');
            // }
            // let getOver = function getOver() {
            //
            //     let fetchUrl = window.location.origin;
            //     fetchUrl += '/wp-json/wp/v2/over?per_page=10&page=1&search='
            //     fetchUrl += searchInputValue;
            //
            //     return _this.axiosSearch(fetchUrl, 'About');
            //
            // }

            // Post types
            // oplossing, knowledge, ervaring, product, faq, over

            let axiosQueue = [getProducts(), getContent()];
            if (axiosQueue) {
                return Promise.all(axiosQueue)
                        .then(function (data) {

                            let allContentLinks = [];

                            for (let i = 0; i < 2; i++) {

                                console.log(data[i]);

                                if (data[i].post_results.length > 0) {
                                    if (data[i].name === 'Catalogus') {
                                        _this.results_catalog = data[i];
                                    } else {
                                        // _this.results_content.push(data[i]);
                                        data[i].post_results.forEach(function (element) {
                                            allContentLinks.push(element)
                                        });
                                    }
                                }
                            }

                            _this.results_content = allContentLinks;
                            _this.has_results = true;
                            _this.loading = false;

                        })
            }
        },
        axiosSearch(toFetchUrl, name) {
            console.log(toFetchUrl);
            return axios.get(toFetchUrl)
                    .then(response => {
                        // Set results to local data
                        // console.log(response)

                        let resultsObj = {
                            name: name,
                            post_results: response.data
                        }

                        return resultsObj;
                    })
                    .catch(e => {
                        let resultsObj = {
                            name: name,
                            post_results: []
                        }
                        return resultsObj;
                    })
        }
    }
}


</script>
